import type { WebhookLog } from '../../lib/flotiq-client/types/api-response';

import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { EMPTY_ARRAY } from '../../lib/globals';
import { getTestProps } from '../../lib/helpers';

import Button from '../Button/Button';
import Panel from '../Panel/Panel';
import WebhookLogsContainer from './WebhookLogsContainer';

interface WebhookLogsProps {
  /**
   * Content object logs array
   */
  logs?: WebhookLog[];
  /**
   * If logs are loading
   */
  loading?: boolean;
  /**
   * On refresh click callback
   */
  onRefresh?: () => void;
  /**
   * Additional panel container classes
   */
  additionalClasses?: string;
  /**
   * Test id for information container
   */
  testId?: string;
}

const WebhookLogs = ({
  logs = EMPTY_ARRAY,
  loading = false,
  onRefresh,
  additionalClasses = '',
  testId = '',
}: WebhookLogsProps) => {
  const { t } = useTranslation();

  return (
    <Panel
      title={t('Webhooks.Logs')}
      isCollapsable={false}
      additionalContainerClasses={twMerge('py-5 px-4', additionalClasses)}
      additionalTitleClasses="text-lg mb-1"
      additionalChildrenClasses="pt-4"
      open
      testId={testId}
    >
      <Button
        onClick={onRefresh}
        buttonColor="blueBordered"
        disabled={loading}
        {...getTestProps(testId, `button-log-refresh`, 'testId')}
      >
        {t('Webhooks.Refresh')}
      </Button>
      <div className="relative mt-4">
        <WebhookLogsContainer
          webhookLogs={logs}
          loading={loading}
          testId={testId}
        />
      </div>
    </Panel>
  );
};

export default WebhookLogs;
